import React, { useState } from 'react';
import { Platform, StyleSheet, View } from 'react-native';

import EditUserEmailEnterMobileOTP from './EditUserEmailEnterMobileOTP';
import EditUserEmailEnterNewEmailOTP from './EditUserEmailEnterNewEmailOTP';
import EditUserEmailMobileOTPSent from './EditUserEmailMobileOTPSent';
import EditUserEmailNewEmailOTPSent from './EditUserEmailNewEmailOTPSent';
import EditUserEmailSuccess from './EditUserEmailSuccess';
import EditUserEnterEmail from './EditUserEnterEmail';

type Props = {
  /**
   * Invoked when editing is successful.
   * Automatically invoked in 3 seconds after successful update.
   */
  onSuccess: () => void;
};

const EditUserEmail = (props: Props) => {
  const [stepCounter, setStepCounter] = useState(0);
  const [newEmail, setNewEmail] = useState('');

  const submitValidatedEmail = (email: string) => {
    // We don't want the step counter to change if we request a new OTP
    if (!stepCounter) {
      setNewEmail(email);
      setStepCounter(1);
    }
  };

  const submitSMSOTPStage = () => {
    setStepCounter(3);
  };

  const submitNewEmailOTPStage = () => {
    setStepCounter(5);
    setTimeout(() => props.onSuccess?.(), 3000);
  };

  return (
    <View
      style={style.root}
      {...Platform.select({ web: { accessibilityRole: 'form' } })}
    >
      {stepCounter === 0 && (
        <EditUserEnterEmail onSubmit={submitValidatedEmail} />
      )}
      {stepCounter === 1 && (
        <EditUserEmailMobileOTPSent
          handleSubmit={() => {
            setStepCounter(2);
          }}
        />
      )}
      {stepCounter === 2 && (
        <>
          <EditUserEmailEnterMobileOTP
            email={newEmail}
            onSuccess={submitSMSOTPStage}
          />
        </>
      )}
      {stepCounter === 3 && (
        <EditUserEmailNewEmailOTPSent
          email={newEmail}
          onNextButtonPress={() => {
            setStepCounter(4);
          }}
        />
      )}
      {stepCounter === 4 && (
        <EditUserEmailEnterNewEmailOTP
          email={newEmail}
          submitEmailOTPStage={() => {}}
          onOTPFulfill={submitNewEmailOTPStage}
        />
      )}
      {stepCounter === 5 && (
        <EditUserEmailSuccess onNextButtonPress={props.onSuccess} />
      )}
    </View>
  );
};

const style = StyleSheet.create({
  root: {
    flex: 1,
  },
});

export default EditUserEmail;
